// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f9286948","498":"8bef3ec0","703":"dd222d96","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};